import { useMutation, useQueryClient } from '@tanstack/react-query';
import { strapiCreateDynamicEntity, userRelationWrite } from '../../api/strapiDynamicEntity';
import type { StrapiManagedUserRow } from '../../api/strapiUsers';
import { MASTER_CRUD_REGISTRY } from '../../masterData/masterCrudRegistry';
import { queryKeys } from '../queryKeys';

const ENTRY = MASTER_CRUD_REGISTRY['sample-detail-surveyors'];

export function useCreateSampleDetailSurveyorMutation(jwt: string | null, workOrderDocumentId: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (args: { sampleInformationPointDocumentId: string; user: StrapiManagedUserRow }) => {
      if (!jwt) throw new Error('Not signed in');
      const userPayload = userRelationWrite(args.user.documentId, args.user.numericId);
      if (userPayload === undefined) {
        throw new Error('User surveyor tidak punya id yang valid untuk Strapi.');
      }
      return strapiCreateDynamicEntity(jwt, ENTRY.apiPlural, {
        sample_information_point: { connect: [args.sampleInformationPointDocumentId] },
        user: userPayload,
      }, ENTRY.populate);
    },
    onSuccess: async () => {
      if (jwt && workOrderDocumentId) {
        await qc.invalidateQueries({ queryKey: queryKeys.workOrderDetail(jwt, workOrderDocumentId) });
      }
      await qc.invalidateQueries({ queryKey: queryKeys.masterEntityList(jwt, 'sample-detail-surveyors') });
    },
  });
}
